<template>
  <div class="question" v-if="active">
    <FindMyGrindLabel v-if="timelinePosition.index > 0 && questionId !== 'results'" />
    <div v-if="questionId === 'quiz-intro'" :class="['question__wrapper', 'question--'+questionId]"
      :style="`background-image:url(${assetPath}lockup-backgrounds/quiz_04-bg@2x.jpg), url(${assetPath}lockup-backgrounds/quiz_04-bg--mobile@2x.jpg)`">
      <Intro :initialized="initialized" />
    </div>
    <div v-if="questionId === 'question-one'" :class="['question__wrapper', 'question--'+questionId]"
      :style="`background-image:url(${assetPath}lockup-backgrounds/quiz_01-bg@2x.jpg), url(${assetPath}lockup-backgrounds/quiz_01-bg--mobile@2x.jpg)`">
      <Q1 :initialized="initialized" />
    </div>
    <div v-if="questionId === 'question-two'" :class="['question__wrapper', 'question--'+questionId]"
      :style="`background-image:url(${assetPath}lockup-backgrounds/quiz_02-bg@2x.jpg), url(${assetPath}lockup-backgrounds/quiz_02-bg--mobile@2x.jpg)`">
      <Q2 :initialized="initialized" />
    </div>
    <div v-if="questionId === 'question-three'" :class="['question__wrapper', 'question--'+questionId]"
      :style="`background-image:url(${assetPath}lockup-backgrounds/quiz_03-bg@2x.jpg), url(${assetPath}lockup-backgrounds/quiz_03-bg--mobile@2x.jpg)`">
      <Q3 :initialized="initialized" />
    </div>
    <div v-if="questionId === 'question-four'" :class="['question__wrapper', 'question--'+questionId]"
      :style="`background-image:url(${assetPath}lockup-backgrounds/quiz_04-bg@2x.jpg), url(${assetPath}lockup-backgrounds/quiz_04-bg--mobile@2x.jpg)`">
      <Q4 :initialized="initialized" />
    </div>
    <div v-if="questionId === 'question-five'" :class="['question__wrapper', 'question--'+questionId]"
      :style="`background-image:url(${assetPath}lockup-backgrounds/quiz_05-bg@2x.jpg), url(${assetPath}lockup-backgrounds/quiz_05-bg--mobile@2x.jpg)`">
      <Q5 :initialized="initialized" />
    </div>
    <div v-if="questionId === 'question-six'" :class="['question__wrapper', 'question--'+questionId]"
      :style="`background-image:url(${assetPath}lockup-backgrounds/quiz_06-bg@2x.jpg), url(${assetPath}lockup-backgrounds/quiz_06-bg--mobile@2x.jpg)`">
      <Q6 :initialized="initialized" />
    </div>
    <div v-if="questionId === 'results' && active" :class="['question__wrapper', 'question--'+questionId]">
      <Results :initialized="initialized" @resetRC="resetRC" @executeRC="executeRC" @getProducts="getProducts" />
    </div>
    <Indicator v-if="questionId !== 'quiz-intro' && questionId !== 'results'" :qid="questionId" />
  </div>
</template>

<script>
import { assetPath } from './../mixins/assetPath.js'

import Intro from './Questions/Intro.vue'
import Q1 from './Questions/Q1.vue'
import Q2 from './Questions/Q2.vue'
import Q3 from './Questions/Q3.vue'
import Q4 from './Questions/Q4.vue'
import Q5 from './Questions/Q5.vue'
import Q6 from './Questions/Q6.vue'
import Results from './Questions/Results.vue'
import Indicator from './Questions/Indicator.vue'
import FindMyGrindLabel from '@/components/Questions/FindMyGrindLabel.vue'

export default {
  name: 'Question',
  components: {
    Intro,
    Q1,
    Q2,
    Q3,
    Q4,
    Q5,
    Q6,
    Results,
    Indicator,
    FindMyGrindLabel
  },
  props: {
    index: {
      type: Number,
      default: -1
    },
    questionId: {
      type: String,
      default: ''
    }
  },
  computed: {
    active() {
      return this.$store.state.active.index === this.index
    },
    timelinePosition() {
      return this.$store.state.active
    }
  },
  data() {
    return {
      initialized: false
    }
  },
  mounted () {
    if (this.active) {
      this.init()
    }
  },
  watch: {
    active: function() {
      this.init()
    }
  },
  methods: {
    init() {
      window.setTimeout(() => {
        this.initialized = true
      }, 300)
      clearTimeout(window.setTimeout)
    },
    resetRC() {
      this.$emit('resetRC')
    },
    executeRC() {
      this.$emit('executeRC')
    },
    getProducts() {
      this.$emit('getProducts')
    }
  },
  mixins: [assetPath]
}
</script>

<style lang="scss">

.svg-wrapper {
  margin: 0 auto;
  svg {
    width: 100%;
    height: auto;
  }
}

.accessible-text {
  @include visually-hidden;
}
.question, .question__wrapper {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.question__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden;
  background-position: -9000px 0, 50% 50%;
  background-size: cover, cover;
  background-repeat: no-repeat, no-repeat;
  svg {
    mix-blend-mode: normal;
    path {
      mix-blend-mode: multiply;
    }
    path[fill^='url'] {
      mix-blend-mode: normal;
    }
  }
  & > div:not(.question-overlay) {
    width: 100%;
    svg {
      margin: 0 auto;
    }
  }
  @include breakpoint(large) {
    background-position: 50% 50%, -9000px 0;
  }
}

.buttons {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  position: absolute;
  flex-wrap: wrap;
  div {
    width: 100%;
  }
  input {
    @include visually-hidden();
    &:active, &:focus, &:checked {
      & + label {
        background-color: $green;
      }
    }
  }
  label {
    // height: 4vw;
    @include button-style;
    width: 100%;
    display: block;
    margin: 0;
  }
  @media screen and (min-width: 769px) {
    flex-wrap: nowrap;
  }
}

.question-overlay {
  position: absolute;
  pointer-events: none;
  z-index: map-get($z, 2);
  img {
    display: block;
    width: 100%;
    height: auto;
  }
}
.question-overlay--left {
  left: 0;
  top: 0;
}
.question-overlay--right {
  top: 0;
  right: 0;
}
.question-overlay--top {
  top: 0;
}
.question-overlay--bottom {
  bottom: 0;
}
.question-overlay--left, .question-overlay--right {
  display: none;
}
@media screen and (min-width: 769px) {
  .question-overlay--top, .question-overlay--bottom {
    display: none;
  }  
  .question-overlay--left, .question-overlay--right {
    display: block;
  }

}

.fade-enter-active, .fade-leave-active {
  transition: opacity 300ms;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.question__wrapper svg {
  overflow: visible;
}


[id*='scale-from-right'] > g,
[id*='scale-from-left'] > g,
[id*='scale-from-center'] > g {
  transform: scaleX(0);
  transition: transform 600ms ease;
}
[id*='scale-from-right'] > g {
  transform-origin: center right;
}
[id*='scale-from-left'] > g {
  transform-origin: center left;
}
[id*='scale-from-center'] > g {
  transform-origin: center center;
}

[id*='fade-in'] > g {
  opacity: 0;
  transition: opacity 500ms;
}

[id*='move-down'] {
  & > g {
    transform: translateY(-1000px);
    transform-origin: center center;
    transition: transform 600ms ease;
    transition-delay: 300ms;
  }
  &[id*='2'] > g {
    transition-delay: 200ms;
  }
  &[id*='3'] > g {
    transition-delay: 100ms;
  }
  &[id*='4'] > g {
    transition-delay: 0;
  }
}

.transitioned-in {
  // KILLING ANIMATIONS FOR EVERYTHING EXCEPT THE INTRO, REMOVE THIS WRAPPER TO RESTORE
  [id*='scale-from-right'] > g,
  [id*='scale-from-left'] > g,
  [id*='scale-from-center'] > g {
    transform: scaleX(1);
  }

  [id*='fade-in'] > g {
    opacity: 1;
  }

  [id*='move-down'] > g {
    transform: translateY(0);
  }
}

</style>